import AbrFormat from '../Constants/AbrFormat';

/**
 * A simple solution for inferring ABR format based on the provided manifest or
 * source file.
 */

const inferAbrFormatFromSrc = (src: string): AbrFormat => {
    if (src.match(/\.mpd/)) {
        return AbrFormat.DASH;
    } else if (src.match(/\.m3u/)) {
        return AbrFormat.HLS;
    } else if (src.match(/\.ism/)) {
        return AbrFormat.SMOOTHSTREAMING;
    }

    return AbrFormat.NONE;
};

export default inferAbrFormatFromSrc;